export const UPDATE_ACTIVE_LEVEL_ID = 'UPDATE_ACTIVE_LEVEL_ID';
export const SET_TUTORIAL_PASSED = 'SET_TUTORIAL_PASSED';
export const RESET_TUTORIAL = 'RESET_TUTORIAL';